import React from "react";

const FirstPageIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11.7993 10.5933L9.2126 8L11.8059 5.40667C12.0659 5.14667 12.0659 4.72667 11.8059 4.46667C11.5459 4.20667 11.1259 4.20667 10.8659 4.46667L7.80593 7.52667C7.54593 7.78667 7.54593 8.20667 7.80593 8.46667L10.8659 11.5267C11.1259 11.7867 11.5459 11.7867 11.8059 11.5267C12.0593 11.2733 12.0593 10.8467 11.7993 10.5933ZM4.66593 4C5.0326 4 5.3326 4.3 5.3326 4.66667V11.3333C5.3326 11.7 5.0326 12 4.66593 12C4.29927 12 3.99927 11.7 3.99927 11.3333V4.66667C3.99927 4.3 4.29927 4 4.66593 4Z" fill="#4F4A4A"/>
  </svg>
);

export default FirstPageIcon;
